export function getGoogleMaps () {
  return window && window.google && window.google.maps ? window.google.maps : null
}
